// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/breakers-fuses.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/breakers-fuses/breakers-fuses.js';

mount([g0]);
